"use client";

import React from "react";
import { Map, MapPin, Globe, ClipboardList, Eye, ScanLine, FileText, FileChartColumn, Mail, Car, SquareCheck, Route, WifiOff, Building, CalendarClock, Cloud } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Mapa aktivnosti",
  description: "Imajte pristup lokaciji i statusu aktivnosti cijele vaše radne snage u stvarnom vremenu putem interaktivne mape.",
  icon: Map
}, {
  title: "GPS praćenje",
  description: "Pratite GPS lokaciju djeltnika i voditelja tijekom njihove smjene. Primajte GPS upozorenja u stvarnom vremenu.",
  icon: MapPin
}, {
  title: "Klijentski WEB portal",
  description: "Omogućite svojim klijentima pristup izvještajima o aktivnostima na lokaciji putem korisnički prilagođenog web portala.",
  icon: Globe
}, {
  title: "Zapisnici aktivnosti",
  description: "Analizirajte detaljne zapisnike aktivnosti kako biste procijenili učinak i produktivnost vaših djelatnika.",
  icon: ClipboardList
}, {
  title: "Praćenje u realnom vremenu",
  description: "Pregledavajte i upravljajte svojim djelatnicima i voditeljima u stvarnom vremenu s jednog zaslona.",
  icon: Eye
}, {
  title: "Kontrolne točke",
  description: "Dobijte provjeru aktivnosti i lokacije djelatnika u stvarnom vremenu pomoću NFC ili QR kontrolnih točaka.",
  icon: ScanLine
}, {
  title: "Bilješke",
  description: "Nema više papirnatih dnevnika; vaši djelatnici mogu kreirati bilješke u digitalnom formatu s fotografijama i videozapisima.",
  icon: FileText
}, {
  title: "Izvještaji",
  description: "Omogućite svojim djelatnicima kreiranje digitalnih izvještaja s fotografijama koje možete lako podijeliti s klijentima.",
  icon: FileChartColumn
}, {
  title: "Email obavijesti",
  description: "Šaljite email obavijesti u stvarnom vremenu menadžerima, nadzornicima i klijentima o važnim događajima.",
  icon: Mail
}, {
  title: "Mobilne jedinice",
  description: "Pratite aktivnost i učinak vaših mobilnih timova u stvarnom vremenu kada koriste vozilo za obilazak.",
  icon: Car
}, {
  title: "Zadaci",
  description: "Pratite i potvrdite proces izvršavanja zadataka djelatnika i nadzornika u stvarnom vremenu.",
  icon: SquareCheck
}, {
  title: "Obilasci\xA0",
  description: "Poboljšajte učinak na lokaciji praćenjem završetka obilaska zaštitara u stvarnom vremenu.",
  icon: Route
}, {
  title: "Offline rad",
  description: "Omogućite svojim djelatnicima i voditeljima rad u offline načinu rada kada nema internetske veze.",
  icon: WifiOff
}, {
  title: "Tlocrt",
  description: "Osigurajte svojoj radnoj snazi tlocrte zgrada i vizualne podatke u digitalnom formatu za lakšu navigaciju.",
  icon: Building
}, {
  title: "Praćenje vremena",
  description: "Automatizirajte praćenje vremena zaposlenika i nadzornika. Dobijte jednostavan pristup točnim radnim listovima.",
  icon: CalendarClock
}, {
  title: "Cloud pohrana",
  description: "Softver i podaci naših klijenata pohranjeni su sigurno, koristeći vodeće svjetske web i cloud usluge.",
  icon: Cloud
}];
export default function FeaturesGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section id="featuresgrid" className="bg-muted/30 py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <Card key={index} data-index={index} className="bg-card border-none shadow-sm hover:shadow-md transition-all duration-300 rounded-3xl h-full flex flex-col text-center group">
                <CardHeader className="pt-10 pb-4 flex flex-col items-center gap-5">
                  <div className="relative flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 text-primary group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8" strokeWidth={1.5} />
                    {}
                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-secondary rounded-lg border-2 border-card" />
                  </div>
                  <CardTitle className="font-default text-lg md:text-xl font-bold text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pb-10 flex-grow">
                  <CardDescription className="text-sm md:text-base text-muted-foreground leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}